import React from "react";
import ForgotPasswordModule from "modules/auth/forgot-password/forgot-password.module";

const AuthForgotPasswordPage = (props) => {
  return (
    <div>
      <ForgotPasswordModule {...props} />
    </div>
  );
};

export default AuthForgotPasswordPage;
